import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress } from '../../../../Fct/generics';
export var Magic = createPlugin({
    protocol: 'MAGIC',
    type: 'LIBRARY',
    method: 'magic',
    usePureMethod: true,
    name: 'magic',
    supportedContracts: [
        { chainId: 1, address: '0xC7D810CEc1465C85345eD7C2B103E7E6109eBE47' },
        { chainId: 10, address: '0x92B83232F2579D77BE181Dc2b167f9a542F2e0DE' },
        { chainId: 42161, address: '0xD8d95c30874DfBD9981272c5d0F0729BA523D475' },
        { chainId: 11155111, address: '0x64754348Aa0fb27Cce9c40214e240755bBBcb265' },
    ],
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {},
        },
        output: {},
    }); },
});
